import styled from 'styled-components/macro';

export const WinContainer = styled.div`
  position: fixed;
  top: ${props => props.top};
  left: ${props => props.left};
  width: ${props => props.width};
  height: ${props => props.height};
  background: #FFFFFF;
  border-radius: 12px;
  box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.12);
  padding: 32px;
  z-index: 1001;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  font-family: 'AvertaSemiBold', sans-serif;
`;

export const Title = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: #2C2C2E;
  margin: 0 0 16px 0;
  line-height: 1.3;
  letter-spacing: -0.49px;
`;

export const ImageContainer = styled.div`
  margin: 16px 0;
  max-width: 100%;
  display: flex;
  justify-content: center;
`;

export const Image = styled.img`
  max-width: 100%;
  max-height: 200px;
  border-radius: 8px;
  cursor: ${props => props.clickable ? 'pointer' : 'default'};
  transition: opacity 0.2s ease;
  
  &:hover {
    opacity: ${props => props.clickable ? 0.8 : 1};
  }
`;

export const Content = styled.p`
  font-size: 16px;
  color: #6C6C70;
  margin: 16px 0 24px 0;
  line-height: 1.5;
  letter-spacing: -0.4px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  width: 100%;
  margin-top: auto;
`;

export const PrimaryButton = styled.button`
  background: #007AFF;
  color: #FFFFFF;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
  min-width: 120px;
  
  &:hover {
    background: #0056CC;
  }
  
  &:active {
    background: #004499;
  }
`;

export const SecondaryButton = styled.button`
  background: transparent;
  color: #6C6C70;
  border: 1px solid #D1D1D6;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 120px;
  
  &:hover {
    background: #F2F2F7;
    border-color: #C7C7CC;
  }
  
  &:active {
    background: #E5E5EA;
  }
`;

export const WinContainerModern = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.10);
  padding: 40px 32px 32px 32px;
  min-width: 420px;
  max-width: 600px;
  width: 100%;
  z-index: 1001;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 18px;
  position: relative;
`;

export const BlueDot = styled.div`
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #0A84FF;
  margin-right: 10px;
`;

export const PillLabel = styled.div`
  background: linear-gradient(to left, #000000 0%, #5E5E5E 49.16%, #000000 100%);
  color: #fff;
  font-size: 12px;
  font-family: 'AvertaSemibold', 'Averta', sans-serif;
  border-radius: 20px;
  padding: 2px 8px;
  display: inline-block;
  letter-spacing: -0.15px;
  line-height: 20px;
`;

export const CloseButton = styled.button`
  position: absolute;
  right: 0;
  top: 0;
  background: none;
  border: none;
  font-size: 22px;
  color: #2C2C2E;
  cursor: pointer;
  padding: 0 4px;
  line-height: 1;
  transition: color 0.15s;
  &:hover {
    color: #111;
  }
`;

export const Heading = styled.h2`
  font-size: 44px;
  font-family: 'AvertaBold', 'Averta', sans-serif;
  margin: 0 0 18px 0;
  color: #222;
  padding: 0;
  letter-spacing: -0.53px;
  line-height: 53px;
`;

export const BodyText = styled.div`
  font-size: 18px;
  font-family: 'AvertaRegular', 'Averta', sans-serif;
  color: #222;
  margin-bottom: 32px;
  line-height: 27px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const PrimaryButtonModern = styled.button`
  background: #0A84FF;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 10px;
  font-size: 18px;
  font-family: 'AvertaSemiBold';
  width: 100%;
  cursor: pointer;
  min-height: 48px;
  letter-spacing: -0.23px;
`;

export const SecondaryButtonModern = styled.button`
  background: #fff;
  color: #black;
  border-radius: 8px;
  padding: 10px;
  font-size: 18px;
  font-family: 'AvertaSemiBold';
  width: 100%;
  cursor: pointer;
   border: 2px solid #6D7278;
  min-height: 48px;
  letter-spacing: -0.23px;
`;

export default {
  WinContainer,
  Title,
  ImageContainer,
  Image,
  Content,
  ButtonContainer,
  PrimaryButton,
  SecondaryButton,
  WinContainerModern,
  HeaderRow,
  BlueDot,
  PillLabel,
  CloseButton,
  Heading,
  BodyText,
  ButtonsWrapper,
  PrimaryButtonModern,
  SecondaryButtonModern,
}; 